import { useRef } from 'react';
import { NumbersClaimInput, useClaimFreeNumbersMutation } from '@/types/generated/graphql';

type UseClaimFreeNumbersArgs = {
  onSuccess: (message?: string | null) => void;
  onError?: (message: string) => void;
};

export function useClaimFreeNumbers({ onSuccess, onError }: UseClaimFreeNumbersArgs) {
  const claimedCountRef = useRef(0);

  const [claimMutation, { loading }] = useClaimFreeNumbersMutation({
    onCompleted: (res) => onSuccess(res?.claimFreeNumbers?.message),
    onError: (err) => onError?.(err.message),
    update: (cache) => {
      cache.evict({ id: 'ROOT_QUERY', fieldName: 'checkConfigurationAndRewardOfChannel' });
      cache.evict({ id: 'ROOT_QUERY', fieldName: 'workspaceClaimedFreeNumbers' });
      cache.evict({ id: 'ROOT_QUERY', fieldName: 'assignChannelsV2' });
      cache.evict({ id: 'ROOT_QUERY', fieldName: 'channelsV2' });
      cache.evict({ id: 'ROOT_QUERY', fieldName: 'countChannels' });
      cache.evict({ id: 'ROOT_QUERY', fieldName: 'getAssignedChannelsCount' });
      cache.gc();
    },
  });

  const claim = (cartNumbers: NonNullable<NumbersClaimInput['cartNumbers']>) => {
    claimedCountRef.current = cartNumbers.length;
    claimMutation({ variables: { input: { cartNumbers } } });
  };

  return { claim, loading };
}
